<template>
  <div style="text-align: center">
    <LiquidFill :id="id" :chartData="chartData" />
    <!--:style="{ height: height, width: width }"-->
  </div>
</template>

<script>
  import LiquidFill from "@/components/Echarts/Lvyouyulun/LiquidFill.vue";

  export default {
    name: "Yuqingfengxiandu",
    props: {
      chartData: {
        type: Object,
        default() {
          return {};
        }
      },id: {
        type: String,
        default: "chart"
      },
      width: {
        type: String,
        default: "200px"
      },
      height: {
        type: String,
        default: "200px"
      }
    },
    components: {
      LiquidFill
    },
    data() {
      return {};
    },
    mounted() {}
  };
</script>

<style scoped lang="less"></style>
